/**
 * Fisher–Yates shuffle. Returns a new array and leaves the input untouched.
 * `random` must return a number in [0, 1); it is injectable for deterministic tests.
 */
export function shuffle<T>(arr: readonly T[], random: () => number = Math.random): T[] {
  const copy = [...arr];
  for (let i = copy.length - 1; i > 0; i -= 1) {
    const j = Math.floor(random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy;
}
